import type { DataQualityMeloMaloListItem } from "../../../../EnergyData/EnergyDataQuality/EnergyDataQuality";
import type { EnergyRevenuesListResponse } from "../../../RevenueMonitoring.types";

export function flattenMissingDataSources(data: EnergyRevenuesListResponse) {
  const seenMeterIds = new Set();
  const flatList: DataQualityMeloMaloListItem[] = [];

  data.forEach((item) => {
    item.missing_data_sources.forEach((source) => {
      if (!seenMeterIds.has(source.melo_malo_id)) {
        seenMeterIds.add(source.melo_malo_id);
        flatList.push(source);
      }
    });
  });

  return flatList;
}
